import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getLegalDoc, LEGAL_INDEX } from '../data/legalDocuments';

export function LegalDocPage() {
  const { slug } = useParams();
  const doc = slug ? getLegalDoc(slug) : null;

  if (!slug || !doc) {
    return <Navigate to="/legal" replace />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="border-b border-border bg-card/40 backdrop-blur-sm">
        <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-between gap-4 px-6 py-4">
          <Link
            to="/legal"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-primary"
          >
            <ArrowLeft className="h-4 w-4" />
            All legal documents
          </Link>
          <Link to="/login" className="text-sm text-muted-foreground hover:text-primary">
            Sign in
          </Link>
        </div>
      </div>
      <article className="mx-auto max-w-3xl px-6 py-10">
        <header className="mb-8 border-b border-border pb-6">
          <h1 className="font-heading text-3xl font-bold tracking-tight">{doc.title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">Effective / last updated: {doc.updated}</p>
        </header>
        <div className="max-w-none">
          {doc.sections.map((sec) => (
            <section key={sec.heading} className="mb-8">
              <h2 className="mb-3 font-heading text-lg font-semibold text-foreground">{sec.heading}</h2>
              {sec.paragraphs.map((p, i) => (
                <p key={i} className="mb-3 text-sm leading-relaxed text-muted-foreground">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
        <footer className="mt-12 border-t border-border pt-6 text-xs text-muted-foreground">
          <p className="mb-3">
            <strong className="text-foreground">Not legal advice.</strong> These materials are provided for
            transparency and pilot governance. Have qualified counsel review them for your jurisdiction and use case.
          </p>
          <p>
            Other documents:{' '}
            {LEGAL_INDEX.filter((x) => x.slug !== slug).map((x, idx, arr) => (
              <React.Fragment key={x.slug}>
                {idx > 0 ? ', ' : ''}
                <Link to={`/legal/${x.slug}`} className="text-primary underline-offset-2 hover:underline">
                  {x.title}
                </Link>
                {idx === arr.length - 1 ? '.' : ''}
              </React.Fragment>
            ))}
          </p>
        </footer>
      </article>
    </div>
  );
}
